module.exports = __webpack_public_path__ + "img/homesol_3.62754f40.png";